export default {
  getAutocompleteWorkFloUsages: (state) => state.autocompleteWorkFloUsages,
  getWorkFloUsages: (state) => state.workFloUsages,
  getWorkFloUsage: (state) => (id) => {
    return state.workFloUsages.find(workFloUsage => workFloUsage.id === id)
  },
}